/* @sravni/react-design-system version 0.2.71 */
var css = "._16pnoek._1oeiens {\n  padding: 8px;\n}\n._1484j4f {\n  cursor: pointer;\n}\n._1484j4f:focus-visible {\n  outline: none;\n}\n._1484j4f._1fg5mgf {\n  cursor: auto;\n}\n._b2fzks {\n  max-height: 341px;\n}\n";
var modules_c052660e = {"container":"_16pnoek","dropdown":"_1oeiens","triggerElement":"_1484j4f","disabled":"_1fg5mgf","menu":"_b2fzks"};
import "../../../assets/components/Dropdown/src/Dropdown-ab2e098c.css";

export default modules_c052660e;
export { css };
